import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'

import { compose as recompose } from "recompose";
import { Row, Col, Grid} from 'react-bootstrap';

import ContactForm from "./ContactForm";

import './Contact.css';

const MapWithAMarker = recompose(
  withScriptjs,
  withGoogleMap
)(props =>
  <GoogleMap
    defaultZoom={11}
    defaultCenter={{ lat: 37.5019769, lng: -121.9519048 }}
  >
    <Marker
      position={{ lat: 37.5019769, lng: -121.9519048 }}
    />
  </GoogleMap>
);

class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      gotError: false
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    let data = this.refs.contactForm.getFormData()
    this.props.firebase.push('requests', data)
    .then(() => {
      this.setState({submitted :true})
    })
    .catch(error => {
      this.setState({gotError: true})
      console.log(error)
    })
  }

  render() {
    return (
      <Grid>
        <Col xs={12}>
          <Row>
            <Col xs={12} md={4} mdOffset={1} className="contact-content">
              <p><span className="glyphicon glyphicon-map-marker"></span> 44777 S Grimmer Blvd, Fremont, CA, 94538</p>
              <p><span className="glyphicon glyphicon-phone"></span> +1 415-713-4917</p>
              <p><span className="glyphicon glyphicon-envelope"></span> xin.cai@pristine.design</p>
              <p><span className="glyphicon glyphicon-envelope"></span> jingjing.tang@pristine.design</p>
            </Col>
            <Col xs={12} md={4} mdOffset={1} className="contact-map">
              <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBjJdHseNEcn2gP7AP3GsMFPPuBWoMfNB4&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `300px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </Col>
          </Row>
          <hr />
          <Row>
            {
              !this.state.submitted &&
              <Col xs={12} md={8} mdOffset={1}>
                <div className="contact-prompt" id="project-request">Please provide project details</div>
                <ContactForm handleSubmit={this.handleSubmit} ref="contactForm" />
                {
                  this.state.gotError &&
                  <span style={{color: "red"}}>Something went wrong, please try again.</span>
                }
              </Col>
            }
            {
              this.state.submitted &&
              <Col xs={12} md={8} mdOffset={1} className="text-center">
                <h3>Thanks for contacting us!</h3>
                <h3>We will get back to you in 24 hours.</h3>
              </Col>
            }
          </Row>
        </Col>
      </Grid>
    );
  }
}

export default compose(
  firebaseConnect(['requests']),
  connect()
)(Contact)



// WEBPACK FOOTER //
// ./src/Contact.js